const COLUMN_DELIMITER = ','
const ROW_DELIMITER = '\r\n'

export default (data, filename) => {
  let rows = data.map(row => `"${row.join(`"${COLUMN_DELIMITER}"`)}"`)
  let dataStr = rows.join(ROW_DELIMITER)
  let blob = new Blob(['\uFEFF' + dataStr], {
    type: 'text/csv;charset=utf-8;'
  })

  if (!/\.csv/i.test(filename)) {
    filename += '.csv'
  }

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    let url = URL.createObjectURL(blob)
    let downloadLink = document.createElement('a')
    downloadLink.href = url
    downloadLink.download = filename
    // document.body.appendChild(downloadLink)
    downloadLink.click()
    // document.body.removeChild(downloadLink)
    URL.revokeObjectURL(url)
  }
}



// WEBPACK FOOTER //
// ./src/utils/CSVDownloader.js